/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

// Load global components
import Loading from 'components/Loading/Loading';

// Load local components
import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import EditProjectForm from './EditProjectForm';
import EditProjectSuccess from './EditProjectSuccess';
import EditProjectError from './EditProjectError';

// Load styles
import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  currentProjectDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@inject('actionDrawerStore')
@translate()
@observer
export default class EditProject extends React.Component<*> {
  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { currentProjectDetails, actionDrawerStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.edit_project')} />
          <EditProjectError currentProjectDetails={currentProjectDetails} />
        </div>
      );
    }

    if (actionDrawerStore.archived) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.archived}`}>
          <ActionDrawerHeader title={t('general:actions.edit_project')} />
          <EditProjectSuccess currentProjectDetails={currentProjectDetails} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.edit_project')} />
        <EditProjectForm currentProjectDetails={currentProjectDetails} />
      </div>
    );
  }
}
